import Box, { BoxProps } from 'components/shared/Box'
import Text from 'components/shared/Text'
import { CardOffer } from 'store/api-slice/hooks'
import Link from 'components/shared/Link'
import { FormattedMessage } from 'react-intl'
import AdvantagesPointWithDetails from 'components/shared/UnlimitedCard/components/AdvantagesPointWithDetails'
import { DefaultTheme } from 'styled-components'
import { setIsCalendarModalOpened } from 'store/unlimited-slice'
import { useAppDispatch } from 'store/hooks'
import CheckedList from 'components/shared/CheckedList'

interface FeaturesProps extends BoxProps {
    offers: CardOffer[] | undefined
    cardIndex: number
    isCurrentCardUnlimitedPlus: boolean
    isRenewed?: boolean
    theme?: DefaultTheme
}

const Features = ({
    offers,
    cardIndex,
    isCurrentCardUnlimitedPlus,
    isRenewed,
    theme,
    ...props
}: FeaturesProps) => {
    const dispatch = useAppDispatch()

    const hasDarkMode = theme?.mode === 'dark'

    const openCalendarModal = () => {
        dispatch(setIsCalendarModalOpened(true))
    }

    return (
        <CheckedList {...props}>
            {offers?.map((item, offerIndex) => {
                const { name, showCalendar: isShowCalendar, description } = item

                const hasButton = name?.includes('button')

                return !hasButton ? (
                    <Box key={offerIndex}>
                        <Text
                            variant="body"
                            color={
                                hasDarkMode ? 'grayscale_200' : 'grayscale_900'
                            }
                        >
                            {name}
                        </Text>
                        {isShowCalendar && (
                            <Box>
                                <Text
                                    variant="body"
                                    color={
                                        hasDarkMode
                                            ? 'grayscale_500'
                                            : 'grayscale_700'
                                    }
                                    mb={4}
                                >
                                    {description}
                                </Text>
                                <Link
                                    variant="primary"
                                    textVariant="body"
                                    isUnderlined
                                    icon={null}
                                    onClick={openCalendarModal}
                                    theme={theme}
                                    data-testid={`${
                                        isRenewed
                                            ? 'renew'
                                            : `unlimited-${cardIndex}`
                                    }-button-check-calendar${
                                        isCurrentCardUnlimitedPlus
                                            ? '-plus'
                                            : ''
                                    }`}
                                >
                                    <FormattedMessage
                                        id="annual.cards_calendar_link"
                                        defaultMessage="Sprawdź kalendarz wejść"
                                    />
                                </Link>
                            </Box>
                        )}
                    </Box>
                ) : (
                    !isRenewed && (
                        <AdvantagesPointWithDetails
                            text={name}
                            cardIndex={cardIndex}
                            isCardUnlimitedPlus={isCurrentCardUnlimitedPlus}
                            theme={theme}
                        />
                    )
                )
            })}
        </CheckedList>
    )
}

export default Features
